import { useMutation } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { ADD_FILES_FOR_TALENT, ADD_FILES_FOR_TALENT_UPERCUT } from '@gql/file';

export const useAddFilesForTalent = () => {
    const { isUpercut } = useAuth();
    const { isProIdRequired } = useProId();

    const isUpercutFlow = isUpercut && !isProIdRequired;
    const mutationToUse = isUpercutFlow ? ADD_FILES_FOR_TALENT_UPERCUT : ADD_FILES_FOR_TALENT;

    const [addFilesForTalent, mutationState] = useMutation(mutationToUse);

    return {
        addFilesForTalent,
        ...mutationState,
        mutationName: isUpercutFlow ? 'AddFilesForTalentUpercut' : 'AddFilesForTalent',
        filesCountQueryName: isUpercutFlow ? 'GetFilesCountByTalentsUpercut' : 'GetFilesCountByTalents',
        isUpercutFlow,
    };
};
